import axios from '../../utils/axios';
import { dispatch } from '../index';
import { createSlice } from '@reduxjs/toolkit';
import { DefaultRootStateProps } from '../../types';
import { Contact } from 'types/contact';

const initialState: DefaultRootStateProps['contact'] = {
  contact: {
    count: null,
    hasNext: null,
    hasPrevious: null,
    index: null,
    items: [],
    pages: null,
    size: null
  },
  error: null,
  loading: false,
  loadingData: false,
  addedContact: null,
  deletedContact: null,
  updatedContact: null
};

const slice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },

    getContactSuccess(state, action) {
      state.contact = action.payload;
    },

    postContactSuccess(state, action) {
      state.addedContact = action.payload;
    },

    deleteContactSuccess(state, action) {
      state.deletedContact = action.payload;
    },

    putContactSuccess(state, action) {
      state.updatedContact = action.payload;
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },
    setLoadingData(state, action) {
      state.loadingData = action.payload;
    },

    cleanContactState() {
      return initialState;
    }
  }
});

export default slice.reducer;

export function getContactList(queryString: string) {
  return async () => {
    try {
      dispatch(slice.actions.setLoadingData(true));
      const response = await axios.get('/api/andevos/contactRequests' + queryString);
      dispatch(slice.actions.getContactSuccess(response.data));
      dispatch(slice.actions.setLoadingData(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.setLoadingData(false));
    }
  };
}

export function postContact(contact: Contact) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.post('/api/andevos/contactRequests', contact);
      if (response.status == 201) dispatch(slice.actions.postContactSuccess({ success: true }));
      dispatch(slice.actions.setLoading(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.setLoading(false));
    }
  };
}
export function deleteContact(id: string) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.delete(`/api/andevos/contactRequests/${id}`);
      dispatch(slice.actions.deleteContactSuccess(response.data));
      dispatch(slice.actions.setLoading(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.setLoading(false));
    }
  };
}
export function putContact(contact: Contact) {
  return async () => {
    try {
      dispatch(slice.actions.setLoading(true));
      const response = await axios.put('/api/andevos/contactRequests', contact);
      dispatch(slice.actions.putContactSuccess(response.data));
      dispatch(slice.actions.setLoading(false));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.setLoading(false));
    }
  };
}

export function cleanContactState() {
  return async () => {
    dispatch(slice.actions.cleanContactState());
  };
}
